<script>
import KeywordsApi from "../../../api/KeywordsApi";
import {Listeners} from "../../../constants/listeners";

export default {
    data: () => ({
        yandexWizardClasses: null,
        googleWizards: null,
    }),
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },
        async loadYandexWizardClasses() {
            const wizardClasses = await KeywordsApi.getYandexWizardClasses();
            this.yandexWizardClasses = wizardClasses.map(wizardClass => ({
                value :wizardClass.id,
                label :wizardClass.name,
            }));
        },
        initGoogleWizards() {
            this.googleWizards = Object.entries(this.$tm(`lang.main.wizards.google`))
                .map(([value, label]) => ({value, label}));
        }
    },
    async created() {
        this.initGoogleWizards();
        await this.loadYandexWizardClasses();

        if (!this.item.value.length && this.items && this.items.length > 0) {
            this.item.value.push(this.items[0].value)
        }
    },
    computed: {
        searchEngine() {
            return window.report_db.engine;
        },
        isYandex() {
            return this.searchEngine === 'yandex';
        },
        items() {
            const wizards = this.isYandex ? this.yandexWizardClasses : this.googleWizards;
            return wizards || [];
        },
    },
}
</script>
<template>
    <select class="fieldselect" v-model="item.value" multiple size="5">
        <option v-for="v in items" v-bind:value="v.value" v-text="v.label"></option>
    </select>
</template>

